t = require('views/internal/teacup-with-helpers')('org_bc_intro')

module.exports = t.renderable ({ isEnterprise, hasCSVExport, hasGoldMembers }) ->
  t.div '.product-intro-modal.bc-intro', ->
    number = 0
    introNumber = ->
      number += 1
      t.span '.product-intro-number', ->
        t.text number.toString()

    t.a '.icon-lg.icon-close.dark-hover.product-intro-close.js-close-intro-helper', { href: '#' }

    t.div '.product-intro-header', ->
      if isEnterprise
        t.img '.product-intro-logo', { src: require('images/trello-enterprise-with-text.png'), alt: "Trello Enterprise" }
      else
        t.img '.product-intro-logo', { src: require('images/trello-business-class-with-text.png'), alt: "Trello Business Class" }

    t.hr()

    t.div '.product-intro-section', ->
      t.h2 ->
        if isEnterprise
          t.format 'welcome-to-enterprise'
        else
          t.format 'welcome-to-business-class'
      t.p ->
        t.format 'to-get-started'

    t.div '.product-intro-section', ->
      introNumber()
      t.h3 ->
        t.format 'visit-the-members-tab-to-manage-members'
      t.p ->
        t.format 'you-can-link-your-google-apps-domain-change-roles-and-deactivate-members-and-view-member-activity-on-the-members-tab-above'

    t.div '.product-intro-section', ->
      introNumber()
      t.h3 ->
        t.format 'check-out-the-organization-settings-page'
      t.p ->
        t.format 'to-check-out-organization-and-board-invite-restrictions-and-board-creation-restrictions-click-the-organization-settings-tab-above'

    t.div '.product-intro-section', ->
      introNumber()
      t.h3 ->
        t.format 'organize-your-boards-with-collections'
      t.p ->
        t.format 'scroll-down-on-this-page-to-see-your-teams-boards-and-click-create-a-collecction'

    t.div '.product-intro-section', ->
      introNumber()
      t.h3 ->
        t.format 'supercharge-your-boards-with-Power-Ups'
      t.p ->
        t.format 'open-the-power-ups-menu-in-the-menu-on-the-right-side-of-your-teams-boards-to-integrate-trello'

    t.div '.product-intro-section', ->
      introNumber()
      t.h3 ->
        t.format 'create-bulk-exports-in-one-click'
      t.p ->
        if hasCSVExport
          t.format 'click-the-export-tab-to-open-the-export-dialog-exports-include-all-of-your-organization-s-data-optionally-including-attachments-exports-will-be-in-csv-and-json-format'
        else
          t.format 'click-the-export-tab-to-open-the-export-dialog-exports-include-all-of-your-organization-s-data-optionally-including-attachments-exports-will-be-in-json-format'

    if hasGoldMembers
      t.div '.product-intro-section', ->
        introNumber()
        t.h3 ->
          t.format 'use-board-backgrounds-and-stickers'
        t.p ->
          t.format 'open-the-board-menu-and-select-stickers-or-change-background-you-ll-see-additional-stickers-and-backgrounds-plus-you-can-upload-your-own'

    if !isEnterprise
      t.div '.product-intro-section', ->
        introNumber()
        t.h3 ->
          t.format 'for-billing-info-ellipsis'
        t.p ->
          t.format 'to-see-billing-history-change-a-credit-card-or-change-the-billing-contact-click-the-billing-tab-above'

    t.div '.product-intro-section', ->
      introNumber()
      t.h3 ->
        t.format 'check-the-user-guide'
      t.p { style: 'margin-bottom: 0;' }, ->
        if isEnterprise
          t.format 'everything-else-is-outlined-in-the-enterprise-user-guide'
        else
          t.format 'everything-else-is-outlined-in-the-business-class-user-guide-business-class-features-are-usually-marked-with-this-icon'

    t.p '.product-intro-close-bottom.u-text-align-center.quiet', ->
      t.a '.js-close-intro-helper.dark-hover', { href: '#' }, ->
        t.icon 'close', 'got-it-close-this-helper', { class: 'dark-hover' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_bc_intro.coffee